// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-radio_default__3zsdh","inner":"idt-radio_inner__2jmxh","check":"idt-radio_check__304in","checkInner":"idt-radio_checkinner__hr8st","active":"idt-radio_active__1wtiu"};